import axios from 'axios'
import cookies from 'vue-cookies'
// import dotenv from 'dotenv'
import router from '../../router'
import store from '../../store'

// get environment variables
// dotenv.config()

// create new axios instance with API URL
// const api = axios.create({ 
//   baseURL: "http://localhost:3400"
// });

const api = axios.create({ baseURL: (window.__APP_CONFIG__?.VUE_APP_API || process.env.VUE_APP_API) });

// add API token from cookies before sending API requests
api.interceptors.request.use(
  config => {
      const containsNaN = config.url.includes('NaN')
      if(!containsNaN){
        store.commit('referential/loadingMutation', true);
        store.commit('project/loadingMutation', true);
        config.__triggeredLoader = true;
      }
      // //console.log("WTH is going on?")
      // //console.log(process.env)
      const token = cookies.get('token')
      if (token) {
        config.headers['x-access-token'] = token
      }
      config.headers['Access-Control-Allow-Origin'] = '*'
      return config
    },
    error => Promise.reject(error)
  );
  

// catch unauthorised responses from API and redirect them
 api.interceptors.response.use(
    response => {
      //console.log("[api response] => ",response)
      if(response.config.__triggeredLoader){
        store.commit('referential/loadingMutation', false);
        store.commit('project/loadingMutation', false);
      }
      const newToken = response.headers['x-access-token'] || response.headers['X-Access-Token']
      if (newToken) {
        cookies.set('token', newToken)
        }
      sessionStorage.removeItem('reloaded');
      return response
    },
    error => {
      //console.log("[api error] => ",error.response?.data)
      if (error.response) {
        if (error.config.__triggeredLoader) {
              store.commit('referential/loadingMutation', false);
              store.commit('project/loadingMutation', false);
          }
        if (error.response?.status === 333 && !sessionStorage.getItem('reloaded')){
          sessionStorage.setItem('reloaded', 'true');
          // eslint-disable-next-line no-self-assign
          window.location.href = window.location.href;
          return new Promise(() => {});
        }
        if (error.response.status === 401) {
        const currentRouteName = router.currentRoute.value?.name || router.currentRoute?.name;
        const publicRoutes = ['home', 'forget', 'login'];
        
          if (!publicRoutes.includes(currentRouteName)) {
            console.error("Redirection vers la page d'accueil pour une erreur 401.");
            store.dispatch('auth/logout');
            router.push({ name: 'login' });
          }
        }
      } 
      else if (error.request) {
        console.error("Erreur réseau : Aucune réponse reçue.", error.request);
      } 
      else {
        //console.log("Erreur de configuration Axios [error] :", error)
        console.error("Erreur de configuration Axios :", error.response?.data);
      }
      return Promise.reject(error);
    }
  );

  export default api